/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { useTranslations } from "@/i18n/client";
import { useMemo } from "react";

export const Translate = ({
	children,
	params,
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
}: { children: string; params?: Record<string, any> }): string => {
	const t = useTranslations();

	const result = t(children, params);

	const replaceChildren = useMemo(() => {
		if (!params) {
			return result;
		}
		return result.replace(/{{(.*?)}}/g, (_, key) => {
			return params?.[key] || "";
		});
	}, [result, params]);

	return replaceChildren;
};

export const T = Translate;
